/**
 * This is the domain used for local development. Available when running with `pnpm start-all`.
 */
export const PROTON_LOCAL_DOMAIN = 'proton.dev';
